import React from 'react';

const UpdateMessage = () => {
  return (
    <div>
      <p>
        <strong>Name, email and address: </strong>
        we need this information to identify your donation
        and update the gift aid status on your donation.
      </p>
      <p>We will only use your phone number to match your SMS donations to your gift aid status.
      </p>
    </div>
  );
};

export default UpdateMessage;
